
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import Laboratory from '@/farm/Laboratory'
import ResearchCard from '@/components/ResearchCard.vue'
import Research from '@/Research'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ResearchCard, ValueMeter, FarmStatusCard, TextButton
  },
  props: {
    farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    util() {
      return util
    }
  }
})
export default class StatusBar extends Vue {
  farm!: Farm
}
